import { inmunetApi } from '../../../api';

export const getNotificaciones = async() => {

    try {

        const { data } = await inmunetApi.get(`/notificaciones`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};

export const eliminarNotificacion = async({ id }) => {

    try {

        const { data } = await inmunetApi.delete(`/notificaciones/${ id }`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al eliminar notificación';

        return id;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al eliminar notificación');
        }

    }

};

export const eliminarNotificaciones = async() => {

    try {

        const { data } = await inmunetApi.delete(`/notificaciones`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al eliminar notificaciones';

        return true;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al eliminar notificaciones');
        }

    }

};

export const getConfiguracionNotificaciones = async() => {

    try {

        const { data } = await inmunetApi.get(`/configuracionNotificaciones`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};

export const editarConfiguracionNotificaciones = async({ data: configuracion }) => {

    try {

        let formData = new FormData();
        Object.keys(configuracion).forEach(field => {
            formData.append(field, configuracion[field]);
        });

        const { data } = await inmunetApi.put(`/configuracionNotificaciones`, formData);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al actualizar configuración de notificaciones';

        return data.notificaciones;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al actualizar configuración de notificaciones');
        }

    }

};